import React from "react";
import auth from "./Auth";

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  submit() {
    //auth.login(() => {
    this.props.history.push("/Dashboard");
    //});
  }

  render() {
    return (
      <div className="limiter">
        <div
          className="container-login100"
          style={{ backgroundImage: "url('assets/images/bg-01.jpg')" }}
        >
          <div className="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-54">
            <form className="login100-form validate-form">
              <span className="login100-form-title p-b-49">
                 Smart React App
              </span>

              <div
                class="wrap-input100 validate-input m-b-23"
                data-validate="Username is reauired"
              >
                <span class="label-input100">Username</span>
                <input
                  class="input100"
                  type="text"
                  name="username"
                  placeholder="Type your username"
                />
                <span class="focus-input100" data-symbol="&#xf206;"></span>
              </div>
              <div class="wrap-input100 validate-input" data-validate="Password is required">
                    <span class="label-input100">Password</span>
                    <input class="input100" type="password" name="pass" placeholder="Type your password"/>
                    <span class="focus-input100" data-symbol="&#xf190;"></span>
                </div>
                <div class="text-right p-t-8 p-b-31">
                  
                  </div>
                  
                  <div class="container-login100-form-btn">
                      <div class="wrap-login100-form-btn">
                          <div class="login100-form-bgbtn"></div>
                          <button class="login100-form-btn">
                              Login
                          </button>
                      </div>
                  </div>
                  <div class="flex-col-c p-t-155">
                   
                   Powered  by BRAVINN Technologies 2019

                </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {}
}

export default Login;
